import React, { useState } from 'react';
import { MapPin } from 'lucide-react';
import MapView from '../../MapView';
import RestaurantOverlay from './RestaurantOverlay';
import { isValidDeliveryLocation } from './restaurantUtils';

export default function DeliveryAddressModal({ restaurant, address, onClose, onSave }) {
  const [draft, setDraft] = useState(address || { lat: null, lng: null, address: '', reference: '' });
  const [error, setError] = useState('');

  const handlePoint = (point) => {
    setDraft((current) => ({ ...current, ...point }));
    setError('');
  };

  const handleSave = () => {
    if (!isValidDeliveryLocation(draft)) {
      setError('Selecciona un punto en el mapa y escribe una dirección o referencia.');
      return;
    }
    onSave(draft);
  };

  return (
    <RestaurantOverlay title="Seleccionar dirección de entrega" onClose={onClose} className="rc-address-modal">
      <header className="rc-modal-heading">
        <span className="rc-modal-heading__icon"><MapPin aria-hidden="true" /></span>
        <div><span className="rc-eyebrow">UBICACIÓN DE ENTREGA</span><h2>¿Dónde recibes tu pedido?</h2></div>
      </header>
      <MapView
        pickup={restaurant?.location}
        dropoff={draft?.lat ? draft : null}
        onLocationSelect={handlePoint}
        clickable
        height="310px"
        vehicleColor="#22D3EE"
        vehicleIcon="moto"
      />
      <div className="rc-address-fields">
        <label className="rc-field">
          <span>Dirección, intersección o sector</span>
          <input
            value={draft.address || ''}
            onChange={(event) => setDraft((current) => ({ ...current, address: event.target.value }))}
            placeholder="Ej.: Av. Principal y Calle 2"
          />
        </label>
        <label className="rc-field">
          <span>Referencia de entrega</span>
          <input
            value={draft.reference || ''}
            onChange={(event) => setDraft((current) => ({ ...current, reference: event.target.value }))}
            placeholder="Ej.: casa azul junto a la farmacia"
          />
        </label>
      </div>
      {error && <p className="rc-field-error" role="alert">{error}</p>}
      <footer className="rc-modal-actions">
        <button type="button" className="rc-button rc-button--secondary" onClick={onClose}>Cancelar</button>
        <button type="button" className="rc-button rc-button--primary" onClick={handleSave}>Confirmar dirección</button>
      </footer>
    </RestaurantOverlay>
  );
}
